import {
  getChatPath,
  getChatDetailPath,
  getChatSendPath,
} from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import { chatActions } from "../reducers/chat";
import { toast } from "react-toastify";
import { t } from "i18next";

export const fetchChatList = () => {
  return (dispatch) => {
    return apiService
      .get(getChatPath())
      .then((response) => {
        dispatch(chatActions.fetchChatList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchChatDetail = (id, page, size) => {
  return (dispatch) => {
    return apiService
      .get(getChatDetailPath(id, page, size))
      .then((response) => {
        dispatch(chatActions.fetchChatDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchChatClearDetailList = () => {
  return (dispatch) => {
    dispatch(chatActions.fetchChatDetail({}));
  };
};

export const fetchChatReloadDetail = (id, page, size, reload) => {
  return (dispatch) => {
    return apiService
      .get(getChatDetailPath(id, page, size))
      .then((response) => {
        if (reload == 1)
          toast.success(t("chatListActions.reload"), {
            theme: "colored",
          });
        dispatch(chatActions.fetchChatDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchChatSend = (formData, id) => {
  return (dispatch) => {
    return apiService
      .postMultipart(getChatSendPath(), formData)
      .then((response) => {
        dispatch(fetchChatDetail(id));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

const handleError = (err) => {
  let errorMessage = err.response ? err.response.data.message : err;
  if (!err.response) {
    toast.error(t("actions.error.refreshPage") + err.response, {
      theme: "colored",
    });
  }
  toast.error(errorMessage, { theme: "colored" });
};
